<template>
  <ul :class="brandClasses.list" data-test-id="product-details-bulletin">
    <template v-for="({ label, text, url }, i) in data" :key="i">
      <li v-if="text || label" style="margin-left: 1.25rem">
        <base-link v-if="url" :to="url">
          {{ text || label }}
        </base-link>
        <span v-else>
          <product-barcode :text="text || label!" />
        </span>
      </li>
    </template>
  </ul>
</template>

<script lang="ts" setup>
import type { ProductDetailContent } from '#types/product'

defineProps<{
  data: ProductDetailContent[]
}>()

const { brandClasses } = useAppConfig().components.product.accordions.bulletin
</script>
